import { render } from "./CreditStudyList.vue?vue&type=template&id=b2a49178&scoped=true"
import script from "./CreditStudyList.vue?vue&type=script&lang=js"
export * from "./CreditStudyList.vue?vue&type=script&lang=js"

import "./CreditStudyList.vue?vue&type=style&index=0&id=b2a49178&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a49178"]])

export default __exports__